import { LoadingLazyComponents } from "ict24h-themes-react";
import { AppRouterItem } from "ict24h-themes-react/lib/esm/modules/routers/AppRouters";
import React from "react";
import { lazy } from "react";
import { DE_NGHI_HOAN_UNG_PREFIX_URL } from "./constants/config.de-nghi-hoan-ung";

const DetailPage = lazy(() => import("./pages/DetailPage.DeNghiHoanUng"));
const PreviewPage = lazy(() => import("./pages/PreviewPage.DeNghiHoanUng"));
const DanhSachPhieuToiTaoPage = lazy(
  () => import("./pages/DanhSachPhieuToiTao.DeNghiHoanUng")
);
const CreatePage = lazy(() => import("./pages/CreatePage.DeNghiHoanUng"));
const EditPage = lazy(() => import("./pages/EditPage.DeNghiHoanUng"));
const MyWaitingApprovalPage = lazy(
  () => import("./pages/DanhSachPhieuChoToiDuyet.DeNghiHoanUng")
);
const MyApprovedApprovalPage = lazy(
  () => import("./pages/DanhSachPhieuToiThamGiaPheDuyet.DeNghiHoanUng")
);

export const DeNghiHoanUngRouters: AppRouterItem[] = [
  {
    path: DE_NGHI_HOAN_UNG_PREFIX_URL + "/create",
    element: (
      <LoadingLazyComponents children={<CreatePage />} loadingType="skeleton" />
    ),
  },

  {
    path: DE_NGHI_HOAN_UNG_PREFIX_URL + "/:id" + "/edit",
    element: (
      <LoadingLazyComponents children={<EditPage />} loadingType="skeleton" />
    ),
  },
  {
    path: DE_NGHI_HOAN_UNG_PREFIX_URL + "/my-approval",
    element: (
      <LoadingLazyComponents
        children={<DanhSachPhieuToiTaoPage />}
        loadingType="skeleton"
      />
    ),
  },
  {
    path: DE_NGHI_HOAN_UNG_PREFIX_URL + "/:id" + "/view",
    element: (
      <LoadingLazyComponents children={<DetailPage />} loadingType="skeleton" />
    ),
  },
  {
    path: DE_NGHI_HOAN_UNG_PREFIX_URL + "/:id" + "/preview",
    element: (
      <LoadingLazyComponents
        children={<PreviewPage />}
        loadingType="skeleton"
      />
    ),
  },
  {
    path: DE_NGHI_HOAN_UNG_PREFIX_URL + "/waiting-approval",
    element: (
      <LoadingLazyComponents
        children={<MyWaitingApprovalPage />}
        loadingType="skeleton"
      />
    ),
  },
  {
    path: DE_NGHI_HOAN_UNG_PREFIX_URL + "/my-act-approval",
    element: (
      <LoadingLazyComponents
        children={<MyApprovedApprovalPage />}
        loadingType="skeleton"
      />
    ),
  },
];
